export var DbView;
(function (DbView) {
    DbView["Search"] = "global_search";
})(DbView || (DbView = {}));
